import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { PageHeader } from "@/components/pawkt/PageHeader";
import { Loading } from "@/components/pawkt/Empty";
import { PieChart, ChevronRight } from "lucide-react";

export default function Segments() {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);
  const { data, isLoading } = useQuery({ queryKey: ["segments"], queryFn: async () => (await api.get("/segments")).data });
  const { data: custs, isFetching } = useQuery({ queryKey: ["segment", active], enabled: !!active, queryFn: async () => (await api.get(`/segments/${active}/customers`)).data });

  if (isLoading || !data) return <Loading />;
  return (
    <div>
      <PageHeader title="Customer Segments" subtitle="Dynamic, always-live audiences for targeting" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
        {data.segments.map((s) => (
          <button key={s.key} data-testid={`segment-${s.key}`} onClick={() => setActive(s.key)}
            className={`flex items-center justify-between rounded-xl border p-4 text-left transition-all ${active === s.key ? "border-emerald-400 bg-emerald-50/40" : "border-slate-200 bg-white hover:border-slate-300"}`}>
            <div>
              <div className="flex items-center gap-2"><PieChart className="h-4 w-4 text-emerald-600" /><span className="font-medium text-slate-800">{s.label}</span></div>
              <div className="font-display text-2xl font-bold text-slate-900 mt-1">{s.count}</div>
            </div>
            <ChevronRight className="h-4 w-4 text-slate-300" />
          </button>
        ))}
      </div>
      {active && (
        <div className="rounded-xl border border-slate-200 bg-white">
          <div className="px-4 py-3 border-b border-slate-100 font-medium text-slate-800">{data.segments.find((x) => x.key === active)?.label}</div>
          {isFetching ? <Loading /> : (
            <div className="divide-y divide-slate-100">
              {(custs?.customers || []).length === 0 && <p className="text-sm text-slate-400 py-6 text-center">No customers in this segment</p>}
              {(custs?.customers || []).map((c) => (
                <div key={c.id} onClick={() => navigate(`/customers/${c.id}`)} className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer hover:bg-slate-50">
                  <span className="font-medium flex-1">{c.name}</span>
                  <span className="text-slate-400">{c.mobile}</span>
                  <span className="font-semibold text-slate-800">{inr(c.total_spend)}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
